import {determineCurrentSearchArrivalStartAndEnd} from "@js/parts/search/functions/logic/determineCurrentSearchArrivalStartAndEnd";
import {isJsonString} from "@js/globalFunctions/isJsonString";

export function datalayer_triggerSingleLodgingProductDetail()
{
	if(typeof baseLodgingPushData !== 'undefined' && determineIfDataLayerIsAvailable())
	{
		dataLayer.push({
			'event': 'productDetail',
			'ecommerce': baseLodgingPushData.ecommerce
		});
	}
}

export function datalayer_triggerSingleLodgingViewContent(useSearchTravelParameters, travel_start, travel_end)
{
	if(typeof baseLodgingPushData !== 'undefined' && determineIfDataLayerIsAvailable())
	{
		const dataObject = {
			'event': 'viewContent',
			'content_ids': baseLodgingPushData.content_ids,
			'City': baseLodgingPushData.City,
			'region': baseLodgingPushData.region,
			'country':'Denmark',
			'num_persons':baseLodgingPushData.num_persons,
			'num_animals':baseLodgingPushData.num_animals
		};

		if(useSearchTravelParameters === true)
		{
			const startEnd = determineCurrentSearchArrivalStartAndEnd();
			if (startEnd !== false)
			{
				dataObject.travel_start = determineDatalayerDateString(startEnd.start);
				dataObject.travel_end = determineDatalayerDateString(startEnd.end);
			}
		}
		else
		{
			if(typeof travel_start !== 'undefined' )
				dataObject.travel_start = travel_start;

			if(typeof travel_end !== 'undefined')
				dataObject.travel_end = travel_end;
		}
		dataLayer.push(dataObject);
	}
}

export function datalayer_triggerSearch(searchResult)
{
	if (determineIfDataLayerIsAvailable() && isJsonString(searchResult))
	{
		const push = {event: 'search'};
		const startEnd = determineCurrentSearchArrivalStartAndEnd();
		if(startEnd !== false){
			push.travel_start = determineDatalayerDateString(startEnd.start);
			push.travel_end = determineDatalayerDateString(startEnd.end);
			push.searchWeek = determineDatalayerWeekNr(startEnd.start);
			push.searchDuration = determineDatalayerWeekDuration(startEnd.start,startEnd.end);
		}

		const persons = searchParameters.getParameter(156);
		if(persons !== undefined)
			push.num_persons = persons


		const husdyr = determineNumAnimals();
		if(husdyr !== undefined)
			push.num_animals = husdyr;


		searchResult = JSON.parse(searchResult);
		const contentIds = determineContentIds(searchResult);
		if(contentIds !== false)
			push.content_ids = contentIds;
		dataLayer.push(push);
	}
}

export function determineDatalayerWeekDuration(start, end)
{
	return Math.floor((end.getTime() - start.getTime())/1000/3600/24/7);
}
export function determineDatalayerWeekNr(date)
{
	let onejan = new Date(date.getFullYear(), 0, 1);
	return Math.ceil( (((date.getTime() - onejan.getTime()) / 86400000) + onejan.getDay() + 1) / 7 );
}

export function determineDatalayerDateString(date)
{
	return date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + (date.getDate())).slice(-2)
}

function determineNumAnimals(){
	const husdyr = searchParameters.getParameter('husdyr');
	if(husdyr !== undefined)
	{
		if(husdyr === '3')
		{
			return '2+ Husdyr';
		}
		else if(husdyr === '2' || husdyr === '1')
		{
			return husdyr+' Husdyr';
		}
		else
		{
			return 'Husdyr ikke tilladt';
		}
	}
	return undefined;
}

function determineContentIds(searchResult){
	if(typeof searchResult !== 'object' || typeof searchResult.result === 'undefined' )
		return false;

	const ids = [];
	for(let i = 0; i < searchResult.result.length; i++){
		ids.push(searchResult.result[i].catNr);
		if(i === 4)
			break;
	}
	return ids;
}


